import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CookieNames} from "../../../shared/cookie/cookie-names";
import {CookieService} from "ngx-cookie-service";
import {SessionNames} from "../../../shared/session/session-names";
import {PageDescription} from "../../../shared/pages/page-description";
import {CrystalClearFrontUrl} from "../../../shared/pages/crystal-clear-front-url";
import {CCRolesType} from "../../../model/security/cc-roles-type";
import {Router} from "@angular/router";
import {CcStorageService} from "../../../services/common/cc-storage.service";
import {AppConfigService} from "../../../services/app-config.service";

@Component({
  selector: 'app-billing-sidebar',
  templateUrl: './billing-sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class BillingSidebarComponent implements OnInit {

  sidebarToggledChange: boolean = false;

  transPartKey: string = 'page.archive';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];

  constructor(private router: Router,
              private storageService: CcStorageService,
              private translateService: TranslateService,
              private appConfigService: AppConfigService) {
  }

  ngOnInit() {
    //load from cookies
    if (this.storageService.check(CookieNames.MENU_SIDE_BAR_MAXIMIZED)) {
      if (this.storageService.get(CookieNames.MENU_SIDE_BAR_MAXIMIZED) === 'true') {
        this.sidebarToggledChange = true;
      }
    }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      this.menuItemsTop = [
        this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_BILLING_LIST, roles, false, [], this.appConfigService.billingEnabled),
        // this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_BILLING_HTV, roles, false)
        this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_INVOICE_TASKS, roles, false, [], this.appConfigService.billingEnabled)
      ];
    }
  }

  SizeChanged($event) {
    this.storageService.set(CookieNames.MENU_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean, subItems: MenuItem[] = [], enabled: boolean = true): MenuItem {
    return PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, roles, iconOnly, subItems, enabled);
  }
}
